import { defaultAppConfig } from '@/src/config/defaults';
import { parseAppConfig, type AppConfig } from '@/src/config/schema';

const CONFIG_URL = './viewer.config.json';

export async function loadAppConfig(): Promise<AppConfig> {
  try {
    const response = await fetch(CONFIG_URL);
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }
    const raw = await response.json();
    return parseAppConfig(raw);
  } catch (err) {
    console.warn(
      'Failed to load viewer.config.json; using defaults.',
      err
    );
    return defaultAppConfig;
  }
}
